/**
** JAVASCRIPTS
** Name: Locate
********************************************************************************/

(function() {


  if(document.querySelector('.js-locate')) {



    /**
    ** Variables
    ****************************************/

    const $locate = document.querySelector('.js-locate');


    /**
    ** FUNCTION
    ** Set Map
    ****************************************/

    function setMap() {


      /**
      ** Variables
      ****************************************/

      const lat = $locate.dataset.lat;
      const lng = $locate.dataset.lng;

      var map = L.map('map', {scrollWheelZoom: false}).setView([lat, lng], 14);


      /**
      ** Draw circle
      ****************************************/

      var circle = L.circle([lat,lng], 450);

      circle.setStyle({
        stroke: false,
        color: '#DF1A24',
        fillOpacity: 0.2
      });

      circle.addTo(map);


      /**
      ** Set tiles
      ***************************************/

      var OpenStreetMap_Mapnik = L.tileLayer('//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        attribution: 'donn&eacute;es &copy; <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - Tiles courtesy of <a href="https://hot.openstreetmap.org/">Humanitarian OpenStreetMap Team</a>',
        minZoom: 11,
        maxZoom: 16
      });

      OpenStreetMap_Mapnik.addTo(map);


    }


    /**
    ** Init
    ****************************************/

    // if(window.innerWidth >= 960) {
      setMap();
    // }


  }

})();
